// This value is used as the route for the Auth0 login callback component, and
// also inside the Auth0 login component, which creates a cyclic dependency between
// the route defitions and the components. Pulling this string out into a constant
// breaks the cycle.
export const Auth0CallbackPath = '/auth0login/callback';
